
//******************************Consultas API************************************************** */
import { getCompanyCustomer } from '../../API/Company/CompanyRequest'
import { getCAIProveedor, getSeleccionCAIsProveedor } from '../../API/Proveedores/ProveedoresRequest'
export const verificarCAI = async (informacion) => {
    let IdProveedorCAI = informacion.IdProveedorCAI
    let factura = informacion?.Factura?.toString()
    let fechaFactura = new Date(informacion.FechaFactura)

    const result = await getCAIProveedor(IdProveedorCAI)
    let datosCAI = result[0]

    let mensaje = ''
    let valido = false

    let tamanioFactura = (factura)?.trim()?.length
    if (datosCAI) {
        const tempoProv = await getCompanyCustomer(datosCAI?.IdProveedor)
        let infoProveedor = tempoProv[0]
        if (infoProveedor?.IdCountry === 95) {
            if (!datosCAI?.ProveedorInternacional) {
                if (tamanioFactura === 19) {
                    if (fechaFactura > new Date(datosCAI.FechaVencimiento)) {
                        mensaje = 'La fecha de la factura supero la fecha de vencimiento del CAI seleccionado'
                    } else {
                        let RI = (datosCAI.RangoInicial)?.toString()
                        let RF = (datosCAI.RangoFinal)?.toString()
                        let ND = factura.substring((factura)?.length - 8)
                        let prefijoCAI = datosCAI?.Prefijo.substring(0, 11)
    
                        let prefijo = factura.slice(0, -8)
    
                        let RIF = RI, RFF = RF
                        if (RI.length < 8) {
                            RIF = RI.padStart(8, 0)
    
                        }
    
                        if (RF.length < 8) {
                            RFF = RF.padStart(8, 0)
                        }
    
                        if (parseInt(ND) <= parseInt(RFF) && parseInt(ND) >= parseInt(RIF)) {
                            if (prefijo === prefijoCAI) {
                                if (fechaFactura <= new Date(datosCAI.FechaVencimiento)) {
                                    valido = true
                                }
                            } else {
                                mensaje = 'EL numero de factura no se encuentra dentro de lo valores del CAI del proveedor'
                            }
                        } else {
                            valido = false
                            mensaje = 'EL numero de factura no se encuentra dentro de lo valores del CAI del proveedor'
                        }
    
                    }
                } else {
                    valido = false
                    mensaje = 'El formato de la factura no es correcto.'
                }
            }else{
                 valido = true
                mensaje = 'Valores Correctos'
            }
        }
    }

    return { valido: valido, msj: mensaje }

}

export const ValidarFacturaProveedor = async (informacion) => {
    let IdProveedor = informacion?.IdProveedor
    let IdProveedorCAI = informacion?.IdProveedorCAI
    let factura = informacion?.Factura?.toString()
    let fechaFactura = new Date(informacion.FechaFactura)

    let tamanioFactura =(informacion?.Factura)?.toString().trim()?.length

    let valido = true
    let mensaje = ''
    let valores = { IdProveedorCAI: null }

    const tempoProv = await getCompanyCustomer(IdProveedor)
    let t = {}

    if (tempoProv?.length > 0) {
        if (tempoProv[0]?.IdCountry === 95) {

            if (!IdProveedorCAI) {
                t = await AsignarCAIDocumento(informacion)
                valido = t.valido
                mensaje = t.mensaje
                valores = t.valores

            }

            if (IdProveedorCAI > 0) {

                const result = await getCAIProveedor(IdProveedorCAI)
                let datosCAI = result[0]
                if (!datosCAI?.ProveedorInternacional) {
                    if (tamanioFactura === 19) {
                        let RI = (datosCAI.RangoInicial)?.toString()
                        let RF = (datosCAI.RangoFinal)?.toString()
                        let prefijoCAI = datosCAI?.Prefijo?.substring(0, 11)
                        let ND = factura?.substring((factura)?.length - 8)

                        let prefijo = factura.slice(0, -8)

                        let RIF = RI, RFF = RF
                        if (RI?.length < 8) {
                            RIF = RI.padStart(8, 0)

                        }

                        if (RF?.length < 8) {
                            RFF = RF.padStart(8, 0)
                        }



                        if (parseInt(ND) <= parseInt(RFF) && parseInt(ND) >= parseInt(RIF)) {
                            if (prefijo === prefijoCAI) {

                                if (fechaFactura <= new Date(datosCAI.FechaVencimiento)) {
                                    valores = { IdProveedorCAI: IdProveedorCAI, Factura: factura, FechaFactura: fechaFactura, NombreSucursal: datosCAI?.NombreSucursal }
                                    valido = true
                                    mensaje = 'Valores Correctos'
                                } else {
                                    valido = false
                                    mensaje = 'La fecha de la factura se encuentra fuera del rango de facturación del CAI'
                                }
                            }
                        } else {
                            valido = false
                            mensaje = 'EL numero de factura no se encuentra dentro de lo valores del CAI del proveedor'
                        }

                        if (valido === false) {
                            t = await AsignarCAIDocumento(informacion)
                            valido = t.valido
                            mensaje = t.mensaje
                            valores = t.valores
                        }
                    } else {
                        valido = false
                        mensaje = 'El formato de la factura no es correcto.'
                    }
                } else {
                    valido = true
                    mensaje = 'Valores Correctos'
                }




            }

        }
    }

    return { Valido: valido, Valores: valores, Mensaje: mensaje }
}

export const AsignarCAIDocumento = async (informacion) => {

    let IdProveedor = informacion?.IdProveedor
    let IdProveedorCAI = informacion?.IdProveedorCAI
    let factura = informacion.Factura
    let fechaFactura = new Date(informacion.FechaFactura)
    const temp = await getSeleccionCAIsProveedor(IdProveedor)
    if (temp?.length > 0) {

        let b = temp.find((c) => {
            let RI = (c.RangoInicial)?.toString()
            let RF = (c.RangoFinal)?.toString()
            let ND = factura.substring((factura)?.length - 8)
            let prefijo = factura.slice(0, -8)
            let prefijoCAI = c.Prefijo.substring(0, 11)

            let RIF = RI, RFF = RF
            if (RI.length < 8) {
                RIF = RI.padStart(8, 0)

            }

            if (RF.length < 8) {
                RFF = RF.padStart(8, 0)
            }

            if (parseInt(ND) <= parseInt(RFF) && parseInt(ND) >= parseInt(RIF)) {
                if (prefijo === prefijoCAI) {

                    if (fechaFactura <= new Date(c.FechaVencimiento)) {
                        return c
                    }
                }
            }

        });

        if (b) {
            return {
                valido: true, mensaje: 'CAI encontrado',
                valores: { IdProveedorCAI: b?.IdProveedorCAI, Factura: factura, FechaFactura: fechaFactura, NombreSucursal: b?.NombreSucursal }
            }

        } else {
            return { valido: false, mensaje: 'No se ha encontrado algún CAI del proveedor en relacion a la factura y la fecha ingresada ', valores: null }

        }
    } else {
        return { valido: false, mensaje: 'No se ha encontrado algún CAI del proveedor', valores: null }
    }
}

